// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsPaymentWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  CappsPaymentWebApiHandler_previewApplicationPayment,
  CappsPaymentWebApiHandler_startPaymentMethodSession,
  CappsPaymentWebApiHandler_submitApplicationPayment,
} from '@zg-rentals/ts-capps-client';

import type {
  PreviewApplicationPaymentRequestDto,
  PreviewApplicationPaymentResponseDto,
  StartPaymentMethodSessionRequestDto,
  StartPaymentMethodSessionResponseDto,
  SubmitApplicationPaymentRequestDto,
  SubmitOrderResponseDto,
} from '@zg-rentals/ts-capps-client';

export interface CappsPaymentWebApiHandler_previewApplicationPayment_Args {
  postData: PreviewApplicationPaymentRequestDto;
}

export type CappsPaymentWebApiHandler_previewApplicationPayment_Options = UseMutationOptions<
  PreviewApplicationPaymentResponseDto,
  unknown,
  CappsPaymentWebApiHandler_previewApplicationPayment_Args
>;

export const useCappsPaymentWebApiHandler_previewApplicationPayment = ({
  httpClient,
  ...options
}: Omit<CappsPaymentWebApiHandler_previewApplicationPayment_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsPaymentWebApiHandler_previewApplicationPayment_Args) =>
      CappsPaymentWebApiHandler_previewApplicationPayment(args.postData, httpClient),
  });
};

export interface CappsPaymentWebApiHandler_startPaymentMethodSession_Args {
  postData: StartPaymentMethodSessionRequestDto;
}

export type CappsPaymentWebApiHandler_startPaymentMethodSession_Options = UseMutationOptions<
  StartPaymentMethodSessionResponseDto,
  unknown,
  CappsPaymentWebApiHandler_startPaymentMethodSession_Args
>;

export const useCappsPaymentWebApiHandler_startPaymentMethodSession = ({
  httpClient,
  ...options
}: Omit<CappsPaymentWebApiHandler_startPaymentMethodSession_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsPaymentWebApiHandler_startPaymentMethodSession_Args) =>
      CappsPaymentWebApiHandler_startPaymentMethodSession(args.postData, httpClient),
  });
};

export interface CappsPaymentWebApiHandler_submitApplicationPayment_Args {
  postData: SubmitApplicationPaymentRequestDto;
}

export type CappsPaymentWebApiHandler_submitApplicationPayment_Options = UseMutationOptions<
  SubmitOrderResponseDto,
  unknown,
  CappsPaymentWebApiHandler_submitApplicationPayment_Args
>;

export const useCappsPaymentWebApiHandler_submitApplicationPayment = ({
  httpClient,
  ...options
}: Omit<CappsPaymentWebApiHandler_submitApplicationPayment_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsPaymentWebApiHandler_submitApplicationPayment_Args) =>
      CappsPaymentWebApiHandler_submitApplicationPayment(args.postData, httpClient),
  });
};
